<template>
  <div>
    <b-modal
        id="template-variable-modal"
        centered
        size="lg"
        :title="$t('components.template_variable_modal.title')"
        title-class="font-18"
        ok-only
        :ok-title="$t('components.template_variable_modal.close')"
        @hidden="$emit('hidden')"
    >
      <b-row>
        <b-col v-for="(variable, idx) in variables" :key="idx" cols="12" xl="4">
          <div class="card border shadow-none" :class="{'disabled': variable.type === 'link' && !checkDisable}">
            <div class="text-body">
              <div class="p-2">
                <div class="d-flex">
                  <div class="avatar-xs align-self-center me-2">
                    <div
                        class="avatar-title rounded bg-transparent font-size-20"
                        :class="variable.type === 'link' ? 'text-primary' : 'text-warning'"
                    >
                      <i class="mdi" :class="variable.type === 'link' ? 'mdi-link' : 'mdi-text'"></i>
                    </div>
                  </div>

                  <div class="overflow-hidden me-auto">
                    <h5 class="font-size-13 text-truncate mb-1">{{ variable.name }}</h5>
                    <b-badge class="py-2 text-muted" variant="light">{{ variable.val }}</b-badge>
                  </div>

                  <div class="ms-2">
                    <b-dropdown
                        toggle-class="font-size-16 text-muted p-0"
                        menu-class="dropdown-menu-end"
                        variant="white"
                        right
                        :disabled="variable.type === 'link' && !checkDisable"
                    >
                      <template #button-content>
                        <i class="mdi mdi-dots-horizontal"></i>
                      </template>
                      <b-dropdown-item href="#" v-clipboard:copy="variable.val">
                        <i class="mdi mdi-content-copy text-secondary"></i>
                        {{ $t('components.template_variable_modal.copy') }}
                      </b-dropdown-item>
                      <b-dropdown-item href="#" @click="addEditor(variable.val)">
                        <i class="mdi mdi-plus-circle-outline text-success"></i>
                        {{ $t('components.template_variable_modal.add') }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "TemplateVariableModal",
  props: ['type'],
  data() {
    return {
      variables: {
        buyer_name: {
          name: this.$t('components.template_variable_modal.buyer_name'),
          val: '{{buyer_name}}',
          type: 'value'
        },
        company_name: {
          name: this.$t('components.template_variable_modal.company_name'),
          val: '{{company_name}}',
          type: 'value'
        },
        order_id: {
          name: this.$t('components.template_variable_modal.order_id'),
          val: '{{order_id}}',
          type: 'value'
        },
        order_purchase_date: {
          name: this.$t('components.template_variable_modal.order_purchase_date'),
          val: '{{order_purchase_date}}',
          type: 'value'
        },
        order_item_count: {
          name: this.$t('components.template_variable_modal.order_item_count'),
          val: '{{order_item_count}}',
          type: 'value'
        },
        order_total_price: {
          name: this.$t('components.template_variable_modal.order_total_price'),
          val: '{{order_total_price}}',
          type: 'value'
        },
        earliest_ship_date: {
          name: this.$t('components.template_variable_modal.earliest_ship_date'),
          val: '{{earliest_ship_date}}',
          type: 'value'
        },
        item_title: {
          name: this.$t('components.template_variable_modal.item_title'),
          val: '{{item_title}}',
          type: 'value'
        },
        latest_ship_date: {
          name: this.$t('components.template_variable_modal.latest_ship_date'),
          val: '{{latest_ship_date}}',
          type: 'value'
        },
        earliest_delivery_date: {
          name: this.$t('components.template_variable_modal.earliest_delivery_date'),
          val: '{{earliest_delivery_date}}',
          type: 'value'
        },
        product_list: {
          name: this.$t('components.template_variable_modal.product_list'),
          val: '{{{product_list}}}',
          type: 'link'
        },
        contact_seller: {
          name: this.$t('components.template_variable_modal.contact_seller'),
          val: '{{{contact_seller}}}',
          type: 'link'
        },
        feedback_request: {
          name: this.$t('components.template_variable_modal.feedback_request'),
          val: '{{{feedback_request}}}',
          type: 'link'
        },
        feedback_removal: {
          name: this.$t('components.template_variable_modal.feedback_removal'),
          val: '{{{feedback_removal}}}',
          type: 'link'
        },
        logo_image: {
          name: this.$t('components.template_variable_modal.logo_image'),
          val: '{{{logo_image}}}',
          type: 'link'
        }
      }
    }
  },
  computed: {
    checkDisable() {
        if (this.type) {
          return this.type === 'customEmail';
        }
        return false
    }
  },
  methods: {
    addEditor(val) {
      this.$emit('addVariable', val)
    },
  }
}
</script>

<style scoped>

</style>